module.exports = __webpack_public_path__ + "static/media/Icon-Delete-Gray.392f7ad5.svg";